import Chip, { type ChipProps } from "@mui/material/Chip";

type ChipColor = ChipProps["color"];

const COLOR_BY_LABEL: Record<string, ChipColor> = {
  // Ученики
  Учится: "success",
  Каникулы: "warning",
  Ушёл: "default",
  // Начисления/платежи
  Оплачено: "success",
  Частично: "warning",
  Просрочено: "error",
  Ожидает: "default",
  // Преподаватели / пользователи
  Работает: "success",
  "Ожидает подтверждения": "warning",
  Неактивен: "default",
  Активен: "success",
  // Группы
  Активна: "success",
  Новая: "info",
  "Идёт набор": "warning",
  Закрыта: "default",
  Архив: "default",
  // Уведомления
  "В очереди": "info",
  Отправлено: "success",
  Ошибка: "error",
  // Посещаемость
  Был: "success",
  "Не был": "error",
  Опоздал: "warning",
  "По уважительной причине": "info",
  "Урок отменён": "default",
  Пробный: "info",
  Запланирован: "default",
  // Журнал/посещаемость — статус отметки урока
  Отмечен: "success",
  "Не отмечен": "warning",
  // Заявки/воронка (ТЗ §2.9)
  "Новая заявка": "info",
  Связались: "info",
  "Записан на пробный": "warning",
  "Пробный проведён": "warning",
  Зачислен: "success",
  Отказ: "error",
  // Интеграции (SMS/Telegram)
  Подключено: "success",
  Выключено: "default",
};

export function StatusChip({ label }: { label: string }) {
  const color = COLOR_BY_LABEL[label] ?? "default";
  return <Chip label={label} color={color} size="small" variant={color === "default" ? "outlined" : "filled"} />;
}
